

export class PoiDetailsAddInput implements IPoiDetailsAddInput {
    /** The auto-generated id of the company details master */
    resellerCompanyId!: number;
    /** The company type should be All or Selected */
    companyType!: string;
    /** The branch type should be All or Selected */
    branchType!: string;
    /** The place name with 255 character limit */
    placeName!: string;
    /** The latitude of selected place */
    latitude!: number;
    /** The longitude of selected place */
    longitude!: number;
    /** The tolerance of selected place */
    tolerance!: number;
    /** The auto generated id from poi type master */
    poiTypeId!: number;
    /** The description with 5000 character limit */
    description!: string;
    /** The street1 with 255 character limit */
    street1!: string;
    /** The street2 with 255 character limit */
    street2!: string;
    /** The zip code with 6 character limit */
    zipCode!: string;
    /** The auto generated id from city master */
    cityId!: number;
    /** The auto generated id from company details master */
    companyDetailsId!: number;
    /** The auto generated id from branch details master */
    branchDetailId!: number;

    constructor(data?: IPoiDetailsAddInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.resellerCompanyId = _data["resellerCompanyId"];
            this.companyType = _data["companyType"];
            this.branchType = _data["branchType"];
            this.placeName = _data["placeName"];
            this.latitude = _data["latitude"];
            this.longitude = _data["longitude"];
            this.tolerance = _data["tolerance"];
            this.poiTypeId = _data["poiTypeId"];
            this.description = _data["description"];
            this.street1 = _data["street1"];
            this.street2 = _data["street2"];
            this.zipCode = _data["zipCode"];
            this.cityId = _data["cityId"];
            this.companyDetailsId = _data["companyDetailsId"];
            this.branchDetailId = _data["branchDetailId"];
        }
    }

    static fromJS(data: any): PoiDetailsAddInput {
        data = typeof data === 'object' ? data : {};
        let result = new PoiDetailsAddInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["resellerCompanyId"] = this.resellerCompanyId;
        data["companyType"] = this.companyType;
        data["branchType"] = this.branchType;
        data["placeName"] = this.placeName;
        data["latitude"] = this.latitude;
        data["longitude"] = this.longitude;
        data["tolerance"] = this.tolerance;
        data["poiTypeId"] = this.poiTypeId;
        data["description"] = this.description;
        data["street1"] = this.street1;
        data["street2"] = this.street2;
        data["zipCode"] = this.zipCode;
        data["cityId"] = this.cityId;
        data["companyDetailsId"] = this.companyDetailsId;
        data["branchDetailId"] = this.branchDetailId;
        return data; 
    }
}

export interface IPoiDetailsAddInput {
    /** The auto-generated id of the company details master */
    resellerCompanyId: number;
    /** The company type should be All or Selected */
    companyType: string;
    /** The branch type should be All or Selected */
    branchType: string;
    /** The place name with 255 character limit */
    placeName: string;
    /** The latitude of selected place */
    latitude: number;
    /** The longitude of selected place */
    longitude: number;
    /** The tolerance of selected place */
    tolerance: number;
    /** The auto generated id from poi type master */
    poiTypeId: number;
    /** The description with 5000 character limit */
    description: string;
    /** The street1 with 255 character limit */
    street1: string;
    /** The street2 with 255 character limit */
    street2: string;
    /** The zip code with 6 character limit */
    zipCode: string;
    /** The auto generated id from city master */
    cityId: number;
    /** The auto generated id from company details master */
    companyDetailsId: number;
    /** The auto generated id from branch details master */
    branchDetailId: number;
}

